module.exports = __webpack_public_path__ + "static/media/microscopy-yliv-01 1.86fbfc15.png";